import styled, { css } from 'styled-components';
import React from 'react';
import { ImageContentfulModel } from 'src/api/models/Image';
import { GatsbyImage } from 'gatsby-plugin-image';

const ImageContainer = styled.div<{ height?: number; width?: number }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ height }) =>
    !height
      ? ''
      : css`
          height: ${height}px;
        `}

  ${({ width }) =>
    !width
      ? ''
      : css`
          width: ${width}px;

          @media screen and (max-width: ${width}px) {
            width: 100%;
          }
        `}
`;

export default function getDynamicImage(imageProps: ImageContentfulModel): React.ReactNode {
  if (imageProps.image.gatsbyImageData) {
    return (
      <ImageContainer
        width={imageProps.width}
        height={imageProps.height}
      >
        <GatsbyImage
          image={imageProps.image.gatsbyImageData}
          alt={imageProps?.title || ''}
        />
      </ImageContainer>
    );
  }
  if (imageProps.image.file?.url) {
    return (
      <img
        src={imageProps.image.file.url}
        alt={imageProps?.title}
      />
    );
  }
}
